// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I_56Mf3k_yimhk {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: var(--ds-space-200, 15px);
  transition: all 0.2s ease;
  border: none;
  border-radius: var(--ds-border-radius-300, 12px);
  background: var(--ds-background-brand-boldest, #1c2b41);
  cursor: pointer;
}
.I_56Mf3k_yimhk._O7_lqSDl3TrDC {
  width: 50px;
  height: 50px;
}
.I_56Mf3k_yimhk._O7_lqSDl3TrDC:hover {
  scale: 1.05;
  background: var(--ds-background-brand-boldest-hovered, #09326c);
}
.I_56Mf3k_yimhk:hover {
  scale: 1.15;
  background: var(--ds-background-brand-boldest-hovered, #09326c);
}
.I_56Mf3k_yimhk::before {
  /* stylelint-disable design-system/ensure-design-token-usage */
  background: conic-gradient(from 180deg at 50% 50%, #ffa900 -52.2deg, #0065ff 89.76deg, #0469ff 145.8deg, #bf63f3 262.8deg, #ffa900 307.8deg, #0065ff 449.76deg);
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 1px;
  border-radius: var(--ds-border-radius-300, 12px);
  -webkit-mask: linear-gradient(var(--ds-background-input, #ffffff) 0 0) content-box, linear-gradient(var(--ds-background-input, #ffffff) 0 0);
  mask-composite: exclude;
  pointer-events: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rovoButton": `I_56Mf3k_yimhk`,
	"cardBackButton": `_O7_lqSDl3TrDC`
};
export default ___CSS_LOADER_EXPORT___;
